import { FaIcon } from '@acp/core-ui';
import { IntegratedCompliancePropertyStatus } from '@acp/shared';
import {
    Box, PopoverArrow, PopoverContent, Text, VStack,
} from '@chakra-ui/react';
import { faExternalLink } from '@fortawesome/pro-solid-svg-icons';
import { NewWorkOrderButton } from '../../property-request';

export function ComplianceInfoPopoverContent({
    complianceStatus,
    address,
    agencyPortfolioPropertyId,
    showEnrolPropertyText = false,
    includePopoverArrow = true,
}: {
    complianceStatus: IntegratedCompliancePropertyStatus;
    address?: string;
    agencyPortfolioPropertyId?: number;
    showEnrolPropertyText?: boolean;
    includePopoverArrow?: boolean;
}) {
    return (
        <PopoverContent>
            {includePopoverArrow && <PopoverArrow />}
            <Box p={3} fontSize="sm" fontWeight="normal" color="charcoal.500" lineHeight={1.5}>
                {
                    complianceStatus === IntegratedCompliancePropertyStatus.Compliant && (
                        <VStack align="left">
                            <Text fontWeight="bold">Compliant*</Text>
                            <Text>
                                A property will be listed as Compliant* where Your Data includes
                                a service provider and last service date for all required services,
                                and services are not overdue.
                            </Text>
                        </VStack>
                    )
                }

                {
                    complianceStatus === IntegratedCompliancePropertyStatus.ComplianceIssues && (
                        <VStack align="left">
                            <Text fontWeight="bold">Compliance issues*</Text>
                            <Text>
                                A property will be listed as having Compliance issues* where
                                Your Data does not include a service provider and/or last service
                                date for all required services, or where last service dates are
                                provided, the services are overdue.
                            </Text>
                            {
                                address !== undefined
                                && agencyPortfolioPropertyId !== undefined
                                && showEnrolPropertyText
                                && (
                                    <Text>
                                        To enrol the property with Detector Inspector to carry out
                                        the service,
                                        <NewWorkOrderButton
                                            variant="link"
                                            target="_blank"
                                            eventGenerator={() => ({
                                                type: 'OPEN',
                                                prefilledAddress: address,
                                                excludeEnrolledProperties: true,
                                            })}
                                            legacyPath={`/JobOrders/add?address=${address}&agencyPortfolioPropertyId=${agencyPortfolioPropertyId}`}
                                            ml={1}
                                            fontWeight="medium"
                                        >
                                            click here.
                                            <FaIcon icon={faExternalLink} ml={1} size="sm" />
                                        </NewWorkOrderButton>
                                    </Text>
                                )
                            }
                        </VStack>
                    )
                }
            </Box>
        </PopoverContent>
    );
}
